import { render, staticRenderFns } from "./RegisterOk.vue?vue&type=template&id=3d5e20f6&"
import script from "./RegisterOk.vue?vue&type=script&lang=js&"
export * from "./RegisterOk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports